import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  MatDialog as MatDialog,
  MatDialogRef as MatDialogRef,
  MatDialogConfig as MatDialogConfig,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DialogData } from "../../_models/dialogData";
import { AppSettings } from "../../_constants/AppSettings";
import { AuthService } from "../../auth/auth.service";
import { HelpInfoService } from "../../_common/help-info.service";
import { Location } from "@angular/common";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Input() userEmail: string;
  @Input() user: string;
  @Input() title: string;
  @Output() openMenuEvent = new EventEmitter<string>();

  constructor(
    private router: Router,
    private authService: AuthService,
    public dialog: MatDialog,
    private helpInfoService: HelpInfoService,
  ) {}

  ngOnInit() {}

  signOut() {
    this.authService.signOut();
  }

  clearCache() {
    sessionStorage.clear();
    let cacheTemplate = localStorage.getItem("template");
    if (cacheTemplate !== null) {
      localStorage.removeItem("template");
    }

    window.location.reload();
  }

  // Display AuditHub release notes.
  aboutAudit(evt: MouseEvent) {
    const target = new ElementRef(evt.currentTarget);
    this.dialog.open(HelpInfoDialog, {
      minWidth: "600px",
      data: {
        trigger: target,
        helperIndex: 14,
        dialogWidth: 600,
        title: 'About AuditHub',
        anchorRight: true,
      },
    });
  }
  navigateToDashboard() {
    this.router.navigate(["audithub/home"]);
  }

  openMenu(value: string) {
    this.openMenuEvent.emit(value);
  }

  openHelpInfo(evt: MouseEvent, title: string): void {
    let indx = 0; // indx: see definition at  ./_constants/AppSettings.ts
    if (title === "New Template") {
      indx = 3;
    } else if (title === "Pocket Reference") {
      indx = 8;
    } else if (title === "Custom Questions") {
      indx = 12;
    } else if (title === "Custom Ranking & Scoring") {
      indx = 13;
    }
    this.helpInfoService.open(evt, indx, { rightPosition: true });
  }
}

@Component({
  selector: "help-info-dialog",
  templateUrl: "help-info-dialog.html",
  styleUrls: ["./header.component.css"],
  standalone: false,
})
export class HelpInfoDialog implements OnInit {
  private readonly _matDialogRef: MatDialogRef<HelpInfoDialog>;
  private readonly triggerElementRef: ElementRef;
  public dialogData: DialogData | undefined;
  constructor(
    _matDialogRef: MatDialogRef<HelpInfoDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      trigger: ElementRef;
      helperIndex: number;
      rightPosition: boolean;
      dialogWidth?: number;
      title?: string;
      anchorRight?: boolean;
    },
  ) {
    this._matDialogRef = _matDialogRef;
    this.triggerElementRef = data.trigger;
  }

  ngOnInit() {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    const rect = this.triggerElementRef.nativeElement.getBoundingClientRect();
    const dialogWidth = this.data.dialogWidth ?? 300;
    const viewportWidth = window.innerWidth;

    if (this.data.anchorRight) {
      matDialogConfig.position = {
        right: '20px',
        top: `${rect.bottom + 20}px`,
      };
    } else {
      let leftPos: number;
      if (this.data.rightPosition == true) {
        leftPos = rect.right + 20;
      } else {
        leftPos = rect.left - 300;
      }
      leftPos = Math.max(10, Math.min(leftPos, viewportWidth - dialogWidth - 20));
      matDialogConfig.position = {
        left: `${leftPos}px`,
        top: `${rect.bottom + 20}px`,
      };
    }
    this._matDialogRef.updatePosition(matDialogConfig.position);

    this.dialogData = AppSettings.HelpInfo.find(
      (h) => h.id === this.data.helperIndex,
    )?.helper;
    if (this.dialogData && this.data.title) {
      this.dialogData = { ...this.dialogData, title: this.data.title };
    }
  }

  cancel(): void {
    this._matDialogRef.close(null);
  }

  closeHelper(): void {
    this._matDialogRef.close(null);
  }
}
